const cities = [
  { name: "Thibodaux", zips: "70301, 70310" },
  { name: "Raceland", zips: "70394" },
  { name: "Mathews", zips: "70375" },
  { name: "Lockport", zips: "70374" },
  { name: "Cut Off", zips: "70345" },
];

const benefits = [
  { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from your Thibodaux home or Nicholls State office in minutes." },
  { icon: "ri-truck-line", title: "Ship Your Documents", desc: "Use overnight shipping from any UPS or FedEx location — we handle every detail from there." },
  { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed before submission to catch errors before they cause costly delays." },
  { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the regional passport agency — no 60-mile drive to New Orleans." },
];

export default function ThibodauxLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Thibodaux &amp; Lafourche Parish
          </h2>
        </div>
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Thibodaux is the seat of Lafourche Parish and the largest city in Bayou Country — a region defined by sugarcane agriculture, offshore oil and gas infrastructure, and a deeply rooted Cajun and Creole cultural identity. The city of roughly 15,000 sits at the northern end of Bayou Lafourche, one of the longest distributary bayous in the country, and serves as the commercial and educational center for a parish that stretches all the way south to Grand Isle on the Gulf of Mexico.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The offshore energy industry drives the most time-sensitive passport demand in this area. Houma and Thibodaux are the land-side gateway for workers rotating to deepwater Gulf of Mexico platforms and, increasingly, to international projects in West Africa, the North Sea, and Southeast Asia. When a driller, subsea engineer, or marine coordinator receives rotation papers for an international platform, the departure timeline is often fixed and non-negotiable. If their passport has lapsed during a long onshore assignment — which is common after two or three years of domestic platform work — they need expedited processing that does not involve a 60-mile round trip to the New Orleans Passport Agency on an uncertain appointment schedule.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Nicholls State University adds another dimension. NSU's international programs, study-abroad partnerships, and faculty research exchanges send dozens of students and professors abroad each year — to France, Italy, Spain, and Latin America. Many students are first-time passport applicants who underestimate how long the process takes. Faculty members heading to conferences often have tight departure windows that standard mail-in processing cannot accommodate. NSU's proximity to the community makes Thibodaux a city where academic travel urgency is a real and recurring passport need.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Sugarcane growers and agricultural business owners also travel internationally — to Australia, Brazil, and Colombia for industry conferences and equipment sourcing — on timelines that do not always allow months for passport processing. Fast Passport Center serves all of Lafourche Parish, from Thibodaux down through Raceland, Lockport, and Cut Off, with professional expedited processing that eliminates the drive and the guesswork.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Thibodaux, LA</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Lafourche Parish &amp; Bayou Country</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Serving Thibodaux, Raceland, Lockport, Cut Off &amp; all of Lafourche Parish
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Remote service — start online, ship documents overnight from Thibodaux</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  Start your order online, then ship your documents overnight — no 60-mile drive to New Orleans required. Most Thibodaux clients receive their passports within 2–9 business days.
                </p>
                <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap">
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Lafourche Parish — start online, ship overnight. No 60-mile round trip to the New Orleans Passport Agency required.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Houma", href: "/houma" },
                    { name: "New Orleans", href: "/new-orleans" },
                    { name: "Baton Rouge", href: "/baton-rouge" },
                    { name: "Slidell", href: "/slidell" },
                    { name: "Hammond", href: "/hammond" },
                    { name: "Lafayette", href: "/lafayette" },
                  ].map((link) => (
                    <a key={link.href} href={link.href} className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap">
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Thibodaux Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a key={i} href="https://fastpassportcenter.com" className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}